import { Bolt, Bookmark, BookOpenCheck, Calculator, ChartNoAxesGantt, ChevronLeft, ChevronRight, Clock, Flag, FlameKindling, Flashlight, Grid2x2, Grid3x3, List, Maximize, MessageCircleQuestion, Minimize, Minus, Newspaper, Pause, PauseCircle, PlayCircle, Plus, ShieldQuestion, ShieldQuestionIcon, X } from "lucide-react";
import React, { useState , useRef ,useEffect} from "react";

import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";


import "./MockTestStyle.css";
import ImageWithFallbackCircle from "../../../../UI/ImageWithFallbackCircle";
import ImageWithFallbackLogo from "../../../../UI/ImageWithFallbackLogo";
import ScientificCalculator from "../../../../UI/ScientificCalculator";
import { getAllQuizSectionsQuestionsOptionsInOne } from "../../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import QuestionOptionsStatic from "./QuestionOptionsStatic";
import QuestionRichContent from "../QuestionRichContent";

const MockTest = ({setShowTestPreview,quizObject}) =>{
   const [position, setPosition] = useState({ x: 0, y: 0 });
   const [sectionalPalletBtn, setSectionalPalletBtn] = useState({
  notVisited:0,
  visited:0,
  answered:0,
  markedAndNotAnswered:0,
  markedAndAnswered:0
  
});
   
   const history = useHistory();
     const dispatch = useDispatch();
     const [snackbarVisible, setSnackbarVisible] = useState(false);
     const [snackbarColor, setSnackbarColor] = useState("#958FDA");
     const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
   
     const [goNextPopUp, setGoNextPopUp] =useState(false);
      const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
             
    const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
      const showSnackbar = () => {
          setSnackbarVisible(true);
        };
        
         const hideSnackbar = () => {
          setSnackbarVisible(false);
        };
        const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        
        ;
        
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
      const appId = useSelector((state)=>state?.app?.app?.ID);
      const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
      
       const [loader , setLoader] =useState({status:false});
       const [animate, setAnimate] = useState(false);
      


         const [sectionsArr, setSectionsArr] = useState([]);
         const [questionsArr, setQuestionsArr] = useState([]);
         const [quizArr, setQuizArr] = useState([]);
       
        const [questionsArrDummy, setQestionsArrDummy] = useState([]);
        const [currentSection, setCurrentSection] = useState("All Sections");
            const [currentQuestionObject, setCurrentQuestionObject] = useState({});
            const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
              const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
        const [ visibility, setVisibility] = useState("public");
        const [ showLeftQueBar, setShowLeftQueBar] = useState(true);
        const [ queTypePopUp, setQueTypePopUp] = useState(false);
        const [ difficultyLevel, setDifficultyLevel] = useState("");
        const [ marks, setMarks] = useState(0);
        const [ negativeMarks, setNegativeMarks] = useState(0);
        const [ divideColumn, setDivideColumn] = useState("");
        const [ enableDisplayMarks, setEnableDisplayMarks] = useState(false);
       const [ enableQueHint, setEnableQueHint] = useState(false);
       const [ showHintPopUp, setShowHintPupUp] = useState(false);
       const [ responseTime, setResponseTime] = useState(1);
       const [ showQuestionOptions, setShowQuestionOptions] = useState(true);
           const [ testDesignValue, setTestDesignValue] = useState("");
     const [ palletDirection, setPalletDirection] = useState("right");
     const [ palletDirectionTemp, setPalletDirectionTemp] = useState("");
     const [ pagenationDirection, setPagenationDirection] = useState("bottom");
     const [fullScreen, setFullScreen] = useState(true);
     const [palletType, setPalletType] = useState("Grid");
      const [openCalculator, setOpenCalculator] = useState(false);
      const [showCalci, setShowCalci] = useState(true);
      const [testName, setTestName] = useState("Mock Test");
      const [overallTestTime, setOverallTestTime] = useState(60*60);
      const [lockSubmitButton, setLockSubmitButton] = useState("false");
      const [isRevealWithTimer, setIsRevealWithTimer] = useState("false");
      const [isRevealMode, setIsRevealMode] = useState("false");
      const [isRestrictQuestionNavigation, setIsRestrictQuestionNavigation] = useState("false");
      const [isLockSections, setIsLockSections] = useState("yes");
      const [allowUserNotes, setAllowUserNotes] = useState("true");
  const [loadSections, setLoadSections] = useState(true);
  const [buttonQuestionObject, setButtonQuestionObject] = useState("");
  const [sectionStatsAll ,setSectionStatsAll]= useState({});
  
       const [ questionPaperVisible, setQuestionPaperVisible] = useState(true);
  // response array  all data set here // when user loads test for first time ,
  // insert all ques (responses)// (iterate all response entry per questions Id In Backend)  , 
  // &  get back response array and set it . (response table=(appid + testid) for many users many attempts per test )
  const [responseArray, setResponseArray] = useState([
    { ID: 1, timer: 0 },
    { ID: 2, timer: 0 },
    { ID: 3, timer: 0 }
  ]);
   
       const [activeColorPickerValue,setActiveColorPickerValue]=useState(
        {color1:"rgba( 105, 95, 95, 0.1)",
        color2:"rgba( 105, 95, 95, 0.2)",
        color3:"rgba( 105, 95, 95, 0.3)",
        color4:"rgba( 105, 95, 95, 0.4)",
        color5:"rgba( 105, 95, 95, 0.5)",
        color6:"rgba( 105, 95, 95, 0.6)",
        color7:"rgba( 105, 95, 95, 0.7)",
        color8:"rgba( 105, 95, 95, 0.8)",
        color9:"rgba( 105, 95, 95, 0.9)",
        color10:"rgba( 105, 95, 95, 1)",
        alpha:1})
 useEffect(()=>{
      
        fireGetAllQuizSectionsQuestionsOptionsInOne();
      },[])
   
useEffect(()=>{
  setShowQuestionOptions(false);setTimeout(()=>{ setShowQuestionOptions(true);},10)
  
},[currentQuestionObject?.ID])

const fireGetAllQuizSectionsQuestionsOptionsInOne=()=>{
   setItemArrLoading([{},{},{},{},{},{}])
    setLoader({status:true});
    console.log({testName:"",type:"questionk",
        postParent:quizObject?.ID,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        postId:quizObject?.ID,menuOrder:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility})
      const apiData = dispatch(getAllQuizSectionsQuestionsOptionsInOne({testName:"",type:"question",
        postParent:quizObject?.ID,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        postId:quizObject?.ID,menuOrder:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
            console.log(response)
            const updatedArr = response?.questions.map(q => ({
  ...q,
  timer: 0
}));
setResponseArray(updatedArr);

            setSectionsArr(response?.sections);
               setQestionsArrDummy(response?.questions)
            // setQuestionsArr(response?.questions);
            setQuestionsArr(getQuestionsFromOneSection(response?.questions,response?.sections.length?response?.sections[0]?.secQuestions:[]));
          
          SetSectionPalletButtons();
            setCurrentSection(response?.sections.length?response?.sections[0]:[])
            setCurrentQuestionObject(getQuestionsFromOneSection(response?.questions,response?.sections.length?response?.sections[0]?.secQuestions:[]).length?getQuestionsFromOneSection(response?.questions,response?.sections.length?response?.sections[0]?.secQuestions:[])[0]:[])
         
          SetQuestionVisited(getQuestionsFromOneSection(response?.questions,response?.sections.length?response?.sections[0]?.secQuestions:[]).length?getQuestionsFromOneSection(response?.questions,response?.sections.length?response?.sections[0]?.secQuestions:[])[0]:[],"visited");
         
            handleQuestionClick(getQuestionsFromOneSection(response?.questions,response?.sections.length?response?.sections[0]?.secQuestions:[]).length?getQuestionsFromOneSection(response?.questions,response?.sections.length?response?.sections[0]?.secQuestions:[])[0]?.ID:"");
            setQuizArr(response?.quiz);
            // console.log(response)
          if(response?.quiz){
           
            setItemArrLoading([])
          setActiveColorPickerValue(response?.quiz?.testInterfaceColor?JSON.parse(response?.quiz?.testInterfaceColor)?.colorScheme?.colors:activeColorPickerValue)
       setTestDesignValue(response?.quiz?.testPalletOrPage)
     setPalletDirection(response?.quiz?.palletDirection)
     setPagenationDirection(response?.quiz?.pagenationDirection)
  setShowCalci(response?.quiz?.showCalci)
       setTestName(response?.quiz?.testName)
       setOverallTestTime(parseInt(response?.quiz?.overallTestTime)*60-1)
       setLockSubmitButton(response?.quiz?.lockSubmitButton)
       setIsRevealWithTimer(response?.quiz?.isRevealWithTimer)
       setIsRevealMode(response?.quiz?.isRevealMode)
       setIsRestrictQuestionNavigation(response?.quiz?.isRestrictQuestionNavigation)
       setIsLockSections(response?.quiz?.isLockSections)
          setResponseMessage(response?.message);  
          setAllowUserNotes(response?.quiz?.allowUserNotes)

        setSnackbarColor("rgba(144, 202, 249,1)");
      
        //  setItemArr( response?.questions?response?.questions:[])
      
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }

useEffect(() => {
  const totals = {
    notVisited: 0,
    visited: 0,
    answered: 0,
    markedAndNotAnswered: 0,
    markedAndAnswered: 0
  };

  sectionsArr?.forEach(section => {
    let questions = [];

    try {
      questions = Array.isArray(section?.secQuestions)
        ? section?.secQuestions
        : JSON.parse(section?.secQuestions || "[]");
    } catch (e) {
      console.error("Invalid secQuestions in section", section?.sectionName);
    }

    totals.notVisited += questions.filter(q => !q?.visited && !q?.answered && !q?.marked).length;
    totals.visited += questions.filter(q => q?.visited && !q?.answered && !q?.marked).length;
    totals.answered += questions.filter(q => q?.visited && q?.answered && !q?.marked).length;
    totals.markedAndNotAnswered += questions.filter(q => q?.visited && !q?.answered && q?.marked).length;
    totals.markedAndAnswered += questions.filter(q => q?.visited && q?.answered && q?.marked).length;
    totals.timeSpent=sectionStatsAll?.timeSpent
  });

  // ✅ Update state once
  setSectionStatsAll(totals);
}, [sectionsArr]); 
const ButtonQuestionInfo = () => {
 

  useEffect(() => {
    const handleMouseMoveQuestionInfo = (event) => {
      setPosition({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener('mousemove', handleMouseMoveQuestionInfo);

    return () => {
      window.removeEventListener('mousemove', handleMouseMoveQuestionInfo);
    };
  }, []);

  return (<div>
    <div
      className={`buttonQuestionInfoCursor ${buttonQuestionObject?.que?.ID ? 'hovered' : ''}`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
      

    > </div>{buttonQuestionObject?.que?.ID?<div  className={`${buttonQuestionObject?.dir=="right"?"buttonQuestionInfoCursor-text-right":buttonQuestionObject?.dir=="left"?"buttonQuestionInfoCursor-text-left"
      :buttonQuestionObject?.dir=="top"?"buttonQuestionInfoCursor-text-top":buttonQuestionObject?.dir=="bottom"?"buttonQuestionInfoCursor-text-bottom":""}`} style={buttonQuestionObject?.dir=="right"?
    {left: `${position.x+120}px`,
    top: `${position.y-10}px`,
  padding:"10px 19px", background:"#fff",textAlign:"center",color:"#222"}:
  buttonQuestionObject?.dir=="left"?
  {left: `${position.x-120}px`,
    top: `${position.y-10}px`,
  padding:"10px 19px", background:"#fff",textAlign:"center",color:"#222"}:buttonQuestionObject?.dir=="top"?
  {left: `${position.x+70}px`,
    top: `${position.y+130}px`,
  padding:"10px 19px", background:"#fff",textAlign:"center",color:"#222"}:buttonQuestionObject?.dir=="bottom"?
  {left: `${position.x+70}px`,
    top: `${position.y-130}px`,
  padding:"10px 19px", background:"#fff",textAlign:"center",color:"#222"}:""}>
   
    <div className=" ellipsisTitleQuizTwoRows" style={{background:"#fff",width:"150px",height:"28px",
    borderRadius:"5px",fontWeight:"999",paddingLeft:"0px",fontWeight:"500",color:"#888",fontSize:"14px",textDecoration:"uppercase"}}>
      
     Que: {buttonQuestionObject?.que?.queName}</div>
       <div style={{display:"flex",justifyContent:"space-between",padding:"0px",marginTop:"10px",fontSize:"12px"}}>
 <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"5px",padding:"5px 5px",background:activeColorPickerValue?.color1}}>
  <div><BookOpenCheck    color={activeColorPickerValue?.color10} size={15}/></div>
        <div> {buttonQuestionObject?.que?.queType}</div>  
          </div>   
          
          <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"5px",padding:"5px 5px",background:activeColorPickerValue?.color1}}>
  <div><MessageCircleQuestion    color={activeColorPickerValue?.color10} size={15}/></div>
        <div> {buttonQuestionObject?.que?.difficultyLevel}</div>  
          </div>
          
          </div>
            <div className="" style={{ display:"flex",borderRadius:"5px",justifyContent:"space-between" ,}}> 
          <div className="" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",margin:"5px",marginLeft:"0px",gap:"5px"
          ,background:activeColorPickerValue?.color1,fontSize:"12px"}}> <Clock style={{position:"relative"}} 
  color={activeColorPickerValue?.color10} size={15}/> {formatTimeQue(getTimerByActiveID(buttonQuestionObject?.que?.ID))}</div>
           {buttonQuestionObject?.que?.enableDisplayMarks=="true"?<div style={{display:"flex",justifyContent:"space-between",gap:"10px",padding:"5px"}}>
 <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:activeColorPickerValue?.color1,
  fontSize:"12px"
 }}>

       <Plus style={{position:"relative"}}   color={activeColorPickerValue?.color10} size={15}/>
          {buttonQuestionObject?.que?.marks}
          </div> <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:activeColorPickerValue?.color1
            ,fontSize:"12px"
          }}>
 <Minus style={{position:"relative"}}   color={activeColorPickerValue?.color10} size={15}/>
            {buttonQuestionObject?.que?.negativeMarks}
          </div>   </div>:""}
     </div>

     <div style={{padding:"5px"}} >
      {buttonQuestionObject?.que?.options?.map((option,index)=>(<>
       <div  style={{ }}>
      <div className=" ellipsisTitleQuiz" style={{ display:"flex",borderRadius:"5px",justifyContent:"left" ,background:"#fff",width:"140px",
    borderRadius:"5px",fontWeight:"999",fontWeight:"500",color:"#888",fontSize:"14px"}}>
     {index+1}: {option?.optionText}</div></div></>))}
      </div>
    </div>:""}
    
  </div>);
};









    
          const divRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const enterFullscreen = () => {
    const el = divRef.current;

    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    } else if (el.msRequestFullscreen) {
      el.msRequestFullscreen();
    }

    setIsFullscreen(true);
  };

  const exitFullscreen = () => {
    if (document?.exitFullscreen) {
      document?.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document?.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document?.msExitFullscreen();
    }

    setIsFullscreen(false);
  };

  // Handle when the user exits fullscreen manually (Esc key, etc.)
  React.useEffect(() => {
    const handleFullscreenChange = () => {
      const fsElement =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;

      setIsFullscreen(!!fsElement);
      // reset fullscreen button on esc btn press
      setFullScreen(!fsElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

 const [isRunning, setIsRunning] = useState(true);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isRunning && overallTestTime > 0) {
      intervalRef.current = setInterval(() => {
        setOverallTestTime(prev => prev - 1);
      }, 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [isRunning]);


const getQuestionsFromOneSection = (questionsArrAll, secQuestionsIDArr) => { 
  let secQuestions = [];

  try {
    secQuestions = Array.isArray(secQuestionsIDArr)
      ? secQuestionsIDArr
      : JSON.parse(secQuestionsIDArr || '[]');
  } catch (e) {
    console.warn("Invalid JSON in secQuestions", e);
    return [];
  }

  // Map of all available questions by ID for fast lookup
  const questionMap = new Map();
  questionsArrAll?.forEach(q => questionMap.set(q?.ID, q));

  // Preserve the order from secQuestions
  return secQuestions
    .map(q => questionMap.get(q?.ID))
    .filter(Boolean); // remove undefined if any ID is not found
};
const findSectionNameByQuestionId = ( questionId) => {
  for (const section of sectionsArr) {
    try {
      const secQuestions = section?.secQuestions
        ? JSON.parse(section?.secQuestions)
        : [];

      const found = secQuestions.some(q => q?.ID === questionId);
      if (found) {
        return section?.sectionName; // return the section name where the question is found
      }
    } catch (error) {
      console.error("Invalid JSON in secQuestions for section:", section?.ID);
    }
  }

  return null; // not found
};

const findSectionIDBysection = ( section) => {
 

  return currentSection?.ID==section?.ID?"true":"false"; // true
};
const getArrayLength =(section)=>{
  return section?.secQuestions?JSON.parse(section?.secQuestions).length:0
}
  useEffect(() => {
    if (overallTestTime <= 0) {
      clearInterval(intervalRef.current);
      setIsRunning(false);
    }
  }, [overallTestTime]);

  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };

  const handleStartPause = () => {
    setIsRunning(prev => !prev);
  };

  const formatTimeQue = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return hours?[
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':'):[
   
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':');
};


// question timer

const [activeID, setActiveID] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isRunning && activeID !== null) {
        setResponseArray(prev =>
          prev.map(q =>
            q.ID === activeID ? { ...q, timer: q.timer + 1 } : q
          )
        );
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isRunning, activeID]);


useEffect(() => {
  setSectionsArr(prev =>
    prev.map(section => {
      let secQuestions = [];

      try {
        secQuestions = Array.isArray(section?.secQuestions)
          ? section.secQuestions
          : JSON.parse(section?.secQuestions || "[]");
      } catch (e) {
        console.warn("Invalid JSON in secQuestions", e);
      }

      // IDs in section
      const secIDs = new Set(secQuestions.map(q => q?.ID?.toString()));

      // Sum timer for questions in this section
      const sectionTime = responseArray
        .filter(q => secIDs.has(q?.ID?.toString()))
        .reduce((sum, q) => sum + (q.timer || 0), 0);
       
      return {
        ...section,
        sectionStats: {
          ...section.sectionStats,
          timeSpent: sectionTime
        }
      };
    })
  );

  // Also compute overall total time
  const totalTime = responseArray.reduce(
    (sum, q) => sum + (q.timer || 0),
    0
  );

  setSectionStatsAll({...sectionStatsAll, timeSpent: totalTime})
 
}, [responseArray]);




    const SetSectionPalletButtons=()=>{
  setQuestionPaperVisible(true);
    
setSectionsArr(prev =>
  prev.map(section => {
    const questions = section?.secQuestions?JSON.parse(section?.secQuestions):[];

    const totalSectionalNotVisited = questions?.filter(q =>
      q?.visited !== "visited" &&
      q?.answered !== "answered" &&
      q?.marked !== "marked"
    )?.length;

    const totalSectionalVisited = questions?.filter(q =>
      q?.visited === "visited" &&
      q?.answered !== "answered" &&
      q?.marked !== "marked"
    )?.length;

    const totalSectionalAnswered = questions?.filter(q =>
      q?.visited === "visited" &&
      q?.answered === "answered" &&
      q?.marked !== "marked"
    )?.length;

    const totalSectionalMarkedAndNotAnswered = questions?.filter(q =>
      q?.visited === "visited" &&
      q?.answered !== "answered" &&
      q?.marked === "marked"
    )?.length;

    const totalSectionalMarkedAndAnswered = questions?.filter(q =>
      q?.visited === "visited" &&
      q?.answered === "answered" &&
      q?.marked === "marked"
    )?.length;
    // console.log(prev)
    return {
      ...section,
      sectionStats: {
        notVisited: totalSectionalNotVisited,
        visited: totalSectionalVisited,
        answered: totalSectionalAnswered,
        markedAndNotAnswered: totalSectionalMarkedAndNotAnswered,
        markedAndAnswered: totalSectionalMarkedAndAnswered
      }
    };
   
  })
);


  }


  const calculateSectionStats = (questions) => {
  const notVisited = questions.filter(q =>
    q.visited !== "visited" &&
    q.answered !== "answered" &&
    q.marked !== "marked"
  ).length;

  const visited = questions.filter(q =>
    q.visited === "visited" &&
    q.answered !== "answered" &&
    q.marked !== "marked"
  ).length;

  const answered = questions.filter(q =>
    q.visited === "visited" &&
    q.answered === "answered" &&
    q.marked !== "marked"
  ).length;

  const markedAndNotAnswered = questions.filter(q =>
    q.visited === "visited" &&
    q.answered !== "answered" &&
    q.marked === "marked"
  ).length;

  const markedAndAnswered = questions.filter(q =>
    q.visited === "visited" &&
    q.answered === "answered" &&
    q.marked === "marked"
  ).length;
  
  return {
    notVisited,
    visited,
    answered,
    markedAndNotAnswered,
    markedAndAnswered
  };
};
const parseQuestions = (secQuestions) => {
  if (typeof secQuestions === 'string') {
    try {
      return JSON.parse(secQuestions);
    } catch (e) {
      console.error("Invalid JSON in secQuestions:", e);
      return [];
    }
  }
  return secQuestions || [];
};
const SetQuestionVisited = (questionObject, status) => {
    setQuestionPaperVisible(true);
  setSectionsArr(prev =>
    prev.map(section => {
     let questions = parseQuestions(section.secQuestions);

      const updatedQuestions = questions.map(q =>
        q.ID === questionObject?.ID ? { ...q, visited: status } : q
      );

      const sectionStats = calculateSectionStats(updatedQuestions);

      return {
        ...section,
        secQuestions: updatedQuestions,
        sectionStats
      };
    })
  );

  // api request 

};

const SetQuestionAnswered = (questionObject, status) => {
    setQuestionPaperVisible(true);
  setSectionsArr(prev =>
    prev.map(section => {
    let questions = parseQuestions(section.secQuestions);

      const updatedQuestions = questions.map(q =>
        q.ID === questionObject?.ID ? { ...q, answered: status } : q
      );

      const sectionStats = calculateSectionStats(updatedQuestions);

      return {
        ...section,
        secQuestions: updatedQuestions,
        sectionStats
      };
    })


  );

   // api request 
};


const SetQuestionClearResponse = (questionObject, status) => {
    setQuestionPaperVisible(true);
  setSectionsArr(prev =>
    prev.map(section => {
    let questions = parseQuestions(section.secQuestions);

      const updatedQuestions = questions.map(q =>
        q.ID === questionObject?.ID ? { ...q, visited: "visited", answered: status, marked: status } : q
      );

      const sectionStats = calculateSectionStats(updatedQuestions);

      return {
        ...section,
        secQuestions: updatedQuestions,
        sectionStats
      };
    })


  );

   // api request 
};


const SetQuestionMarked = (questionObject, status) => {
    setQuestionPaperVisible(true);
  setSectionsArr(prev =>
    prev.map(section => {
     let questions = parseQuestions(section?.secQuestions);
      const updatedQuestions = questions.map(q =>
        q.ID === questionObject?.ID ? { ...q, marked: status } : q
      );

      const sectionStats = calculateSectionStats(updatedQuestions);

      return {
        ...section,
        secQuestions: updatedQuestions,
        sectionStats
      };
    })
  );

   // api request 
};
  const handleQuestionClick = (id) => {
    setActiveID(id);
  };

const getTimerByActiveID = ( activeID) => {
  const question = responseArray.find(q => q.ID === activeID);
  return question ? question.timer : 0;
};

const goTONextQuestion=()=>{
    setQuestionPaperVisible(true);
if(currentQuestionIndex<questionsArr?.length-1) {
   setCurrentQuestionObject(questionsArr[currentQuestionIndex+1]);
   setCurrentQuestionIndex(currentQuestionIndex+1)
     handleQuestionClick(questionsArr[currentQuestionIndex+1]?.ID);
     SetQuestionVisited(questionsArr[currentQuestionIndex+1],"visited");

}
else if(currentSectionIndex<sectionsArr?.length-1){
 setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions));
setCurrentSection(sectionsArr[currentSectionIndex+1]);
             setCurrentSectionIndex(currentSectionIndex+1);setCurrentQuestionIndex(0);
               setCurrentQuestionObject(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions)[0]:[])
               
               setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
                handleQuestionClick(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions)[0]?.ID:"");
          SetQuestionVisited(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex+1]?.secQuestions)[0]:[],"visited");
}
 
} 



const goTOPreviousQuestion=()=>{
    setQuestionPaperVisible(true);
if(currentQuestionIndex>0) {
   setCurrentQuestionObject(questionsArr[currentQuestionIndex-1]);
   setCurrentQuestionIndex(currentQuestionIndex-1)
   handleQuestionClick(questionsArr[currentQuestionIndex-1]?.ID);
   SetQuestionVisited(questionsArr[currentQuestionIndex-1],"visited");
}
else if(currentSectionIndex>0){
  
   setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions));
setCurrentSection(sectionsArr[currentSectionIndex-1]);
             setCurrentSectionIndex(currentSectionIndex-1);
               setCurrentQuestionObject(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)[getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length-1]:[])
              setCurrentQuestionIndex(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length-1);
              // alert(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length)
               setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
                handleQuestionClick(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)[getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length-1]?.ID:"");
          SetQuestionVisited(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)[getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex-1]?.secQuestions)?.length-1]:[],"visited");


              }
 
} 
return(<>
<ButtonQuestionInfo />
 <div  ref={divRef}  className="AreYouSurePopUpFive" style={{borderRadius: '0px',border:"0px solid #fff",background:"#fff"}}>
                 <div style={{background:"rgba(105, 95, 95,0.1)",width:"30px",height:"30px",borderRadius:"50%",position:"absolute",right:"10px",top:"0px",
                     alignContent:"center",textAlign:"center",padding:"5px",margin:"10px",cursor:"pointer"}} onClick={()=>setShowTestPreview()} ><X size={22}  color="rgb(105, 95, 95)"/></div> 
 
 <div className="mockTestTopBar" style={{height:"60px" ,boxShadow:"10px 7px 20px 10px rgba(48,25,131,0.041)"}}>
  <div style={{display:"flex",justifyContent:"center",}}> <div  style={{width:"160px",border:"5px solid #fff",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"0px"}}>
   <ImageWithFallbackLogo src={"https://shop.classmock.com/wp-content/uploads/2025/06/Mock.png"}
    widthOuter={"150px"}
    fireOpenEdit ={()=>{}}  iconSize={28} setOpenFullImg={()=>{}}/>
    </div></div> 
 <div className="hideXsForMock hideSmForMock hideMdForMock ellipsisTitleQuiz" style={{background:"#fff",marginTop:"18px",fontWeight:"999",paddingLeft:"10px"}}>
        {testName}</div>
<div onClick={()=>{setQuestionPaperVisible(false);}} className="hideXsForMock" style={{border:"2px solid #888",borderRadius:"5px",height:"40px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",fontWeight:"999",fontSize:"14px"}}><div   className="palletGridList" style={{background:"#fff"}}><Newspaper style={{position:"relative"}}   color={"#333"} size={20}/></div><div>Question Paper</div></div>
<div className="hideXsForMock" style={{border:"2px solid #888",borderRadius:"5px",height:"40px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",fontWeight:"999",fontSize:"14px"}}><div   className="palletGridList" style={{background:"#fff"}}><FlameKindling style={{position:"relative"}}   color={"#333"} size={25}/></div><div>Instructions</div></div>
<div className="hideXsForMock" style={{border:"2px solid #888",borderRadius:"5px",height:"40px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",}}>
        {fullScreen?<div onClick={()=>{setFullScreen(false);enterFullscreen()}}  className="palletGridList" style={{background:"#fff"}}><Maximize style={{position:"relative"}}   color={"#333"} size={25}/></div>:<div onClick={()=>{setFullScreen(true) ;exitFullscreen();}}  className="palletGridList" style={{background:"#fff"}}><Minimize style={{position:"relative"}}   color={"#333"} size={25}/></div>}
 </div>
<div style={{height:"40px",}}>
<div style={{display:"flex",justifyContent:"center",alignItems:"center",margin:"2px" ,gap:"10px",}}>
    <div onClick={handleStartPause}>
      {isRunning ? <PauseCircle style={{position:"relative",marginTop:"5px"}}   color={activeColorPickerValue?.color10} size={35}/>  : <PlayCircle style={{position:"relative",marginTop:"5px"}}   color={activeColorPickerValue?.color10} size={35}/> }
</div><div style={{fontSize:"20px",fontWeight:"999"}}> <span class="coloredTextMockV1">{formatTime(overallTestTime)}</span> 
      {overallTestTime === 0 && <div style={{ fontSize: '20px', marginTop: '20px' }}>Time's up!</div>}</div> </div>
<div style={{display:"flex",justifyContent:"center",alignItems:"center",margin:"2px" ,gap:"10px",}}>

<div className=" ellipsisTitleQuiz" style={{background:"#fff",width:"150px",marginTop:"-5px",
    borderRadius:"5px",fontWeight:"999",paddingLeft:"10px",fontWeight:"500",color:"#888",fontSize:"13px"}}>{testName}</div>
</div></div>
</div>
 <div style={{display:"grid", gridTemplateColumns: testDesignValue=="pallet"&&palletDirection=="left"?"25% 75% ":testDesignValue=="pallet"&&palletDirection=="left"?"75% 25%":"100%" ,}} >
  
<div>


     { testDesignValue=="pallet"&&palletDirection=="left"?<div></div>:""} <div style={{position:"fixed",left: testDesignValue=="pallet"&&palletDirection=="left"?"25%":"0px",right:testDesignValue=="pallet"&&palletDirection=="right"?"25%":"0px",background:"#fff" 
        ,top:testDesignValue=="pagenation"&&pagenationDirection==="top"?"120px":"60px",bottom:testDesignValue=="pagenation"&&pagenationDirection==="bottom"?"120px":"86px",overflowY:"auto",overflowX:"hidden"}}>
     
      {questionPaperVisible?
      <div style={{padding:"5px",}}>
         <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"0px" ,gap:"10px",}}>
      <div className="quizSectionAll" style={{marginBottom:"5px"}}
      // onClick={()=>{setQuestionsArr(questionsArrDummy);setCurrentSection("")}}
      
      > Section All 
        <div className="quizSectionAllInn" style={{zIndex:"999999999"}}>
          
          <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{}} ><Clock size={20} color={"#222"}/>
     </div>
         <div className="palletInfoTitle"> Time Spent: {sectionStatsAll?.timeSpent?formatTime(sectionStatsAll?.timeSpent):formatTime(0)}</div> 
    </div>
        <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#ddd",color:"#333"}}
     >{sectionStatsAll?.notVisited}</div>
         <div className="palletInfoTitle"> Not Visited</div> 
    </div><div className="palletInfoBtn">
        <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     >{sectionStatsAll?.answered}</div>    <div className="palletInfoTitle"> Answered</div> 
    </div><div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333333",color:"#ffffff"}}
     >{sectionStatsAll?.visited}</div>   <div className="palletInfoTitle"> Not Answered</div> 
    </div>
    <div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333",color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{ sectionStatsAll?.markedAndNotAnswered}</div>
       <div className="palletInfoTitle"> Not Answered And Marked</div> 
    </div><div className="palletInfoBtn">
       <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{ sectionStatsAll?.markedAndAnswered}</div>    <div className="palletInfoTitle"> Answered And Marked</div> 
    </div>
      </div>
      </div>
      <div style={{display:"flex",justifyContent:"left",marginTop:"-15px"}}>
     <div onClick={()=>{}} className="" style={{borderRadius:"5px",width:"30px",height:"30px",padding:"3px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",}}>
        <Bookmark style={{position:"relative"}}   color={activeColorPickerValue?.color10} size={20}/>
        </div>
    <div onClick={()=>{}} className="" style={{borderRadius:"5px",width:"30px",height:"30px",padding:"3px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",}}>
        <Flag style={{position:"relative"}}   color={activeColorPickerValue?.color10} size={20}/>
        </div>
{showCalci=="true"?<div onClick={()=>{setOpenCalculator(true)}} className="" style={{background:"#f1f1f1",borderRadius:"5px",width:"30px",height:"30px",padding:"3px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",}}>
        <Calculator style={{position:"relative"}}   color={activeColorPickerValue?.color10} size={20}/>
</div>:""}</div>

      </div>

       <div className="quizSectionGridClass" style={{alignItems:"center",margin:"0px" ,gap:"10px",}}>
     <div style={{display:"flex",justifyContent:"left",gap:"5px"}}> {sectionsArr?.map((item,index) =>(<div  key={item?.ID || index} 
        onClick={()=>{setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions));setCurrentSection(item);
          setCurrentSectionIndex(index);  setCurrentQuestionIndex(0);
            setCurrentQuestionObject(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[])
             SetQuestionVisited(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[],"visited");
            setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
             handleQuestionClick(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]?.ID:"");
             }} >
        {index<2?<div className={`quizSectionAll `}
       style={{border:"2px solid "+(loadSections?findSectionIDBysection(item)=="true"?activeColorPickerValue?.color10:"#dddddd":"#dddddd"),background:(loadSections?findSectionIDBysection(item)=="true"?activeColorPickerValue?.color1:"#fff":"#fff")}}> <div className="ellipsisTitleQuiz"  >  {item?.sectionName} </div>
        <div className="quizSectionAllInn" style={{zIndex:"999999999"}}>
       <div className="palletInfoTitle">  {item?.sectionName}</div>   
         <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{}} ><Clock size={20} color={"#222"}/>
     </div>
         <div className="palletInfoTitle"> Time Spent: {sectionsArr[index]?.sectionStats?.timeSpent?formatTime(sectionsArr[index]?.sectionStats?.timeSpent):formatTime(0)}</div> 
    </div> <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#ddd",color:"#333"}}
     >{sectionsArr[index]?.sectionStats?.notVisited}</div>
         <div className="palletInfoTitle"> Not Visited</div> 
    </div><div className="palletInfoBtn">
        <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     >{sectionsArr[index]?.sectionStats?.answered}</div>    <div className="palletInfoTitle"> Answered</div> 
    </div><div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333333",color:"#ffffff"}}
     >{sectionsArr[index]?.sectionStats?.visited}</div>   <div className="palletInfoTitle"> Not Answered</div> 
    </div>
    <div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333",color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{sectionsArr[index]?.sectionStats?.markedAndNotAnswered}</div>
       <div className="palletInfoTitle"> Not Answered And Marked</div> 
    </div><div className="palletInfoBtn">
       <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{sectionsArr[index]?.sectionStats?.markedAndAnswered}</div>    <div className="palletInfoTitle"> Answered And Marked</div> 
    </div>
      </div>
      </div>:""}</div>))}
     
      {sectionsArr?.length>2?<div className="quizSectionAllMore" > More Sections
        <div className="quizSectionAllInnMore" style={{margin:"0px" ,gap:"10px",}}>
    
         {sectionsArr?.map((item,index) =>(
          <div  key={item?.ID || index}  
          onClick={()=>{setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions));setCurrentSection(item);
             setCurrentSectionIndex(index);setCurrentQuestionIndex(0);
               setCurrentQuestionObject(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[])
                 SetQuestionVisited(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[],"visited");
           
               setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
                handleQuestionClick(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]?.ID:"");
          }} >
        {index>=2?  <div className= {`quizSectionMoreItem ${item?.ID===currentSection?.ID?"activeQuizSection":""} `} style={{border:"2px solid "+(loadSections?findSectionIDBysection(item)=="true"?activeColorPickerValue?.color10:"#dddddd":"#dddddd"),background:(loadSections?findSectionIDBysection(item)=="true"?activeColorPickerValue?.color1:"#fff":"#fff")}}> <div className="ellipsisTitleQuiz" style={{width:" 150px",display:"flex",justifyContent:"center",alignItems:"center",}}>  {item?.sectionName} </div>
        <div className="quizSectionMoreItemInn" >
            <div className="palletInfoTitle">  {item?.sectionName}</div>   
       <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{}} ><Clock size={20} color={"#222"}/>
     </div>
         <div className="palletInfoTitle"> Time Spent: {sectionsArr[index]?.sectionStats?.timeSpent?formatTime(sectionsArr[index]?.sectionStats?.timeSpent):formatTime(0)}</div> 
    </div> <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#ddd",color:"#333"}}
     >{sectionsArr[index]?.sectionStats?.notVisited}</div>
         <div className="palletInfoTitle"> Not Visited</div> 
    </div><div className="palletInfoBtn">
        <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     >{sectionsArr[index]?.sectionStats?.answered}</div>    <div className="palletInfoTitle"> Answered</div> 
    </div><div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333333",color:"#ffffff"}}
     >{sectionsArr[index]?.sectionStats?.visited}</div>   <div className="palletInfoTitle"> Not Answered</div> 
    </div>
    <div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333",color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{sectionsArr[index]?.sectionStats?.markedAndNotAnswered}</div>
       <div className="palletInfoTitle"> Not Answered And Marked</div> 
    </div><div className="palletInfoBtn">
       <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{sectionsArr[index]?.sectionStats?.markedAndAnswered}</div>    <div className="palletInfoTitle"> Answered And Marked</div> 
    </div>
      </div>
      </div>:""} </div>))}

    
      </div>
        
      </div>:""}
      </div>
       <div style={{display:"flex",justifyContent:"left",gap:"10px"}}>
      <div className="quizSectionAllMore" style={{ margin:"0px" ,gap:"10px",}}> <Clock style={{position:"relative"}}   color={activeColorPickerValue?.color10} size={20}/> {formatTimeQue(getTimerByActiveID(activeID))}</div>
      
        <div className="" style={{margin:"0px" ,}}> 
          {currentQuestionObject?.enableDisplayMarks=="true"?<div style={{display:"flex",justifyContent:"space-between",gap:"10px",padding:"5px"}}>
 <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:activeColorPickerValue?.color1}}>
 <Plus style={{position:"relative"}}   color={activeColorPickerValue?.color10} size={20}/>
          {currentQuestionObject?.marks}
          </div> <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:activeColorPickerValue?.color1}}>
 <Minus style={{position:"relative"}}   color={activeColorPickerValue?.color10} size={20}/>
            {currentQuestionObject?.negativeMarks}
          </div>   </div>:""}
            </div></div>
    
      </div>
      <div className={currentQuestionObject?.divideColumn=="true"? "questionDivideColumn":""} style={{margin:"10px" ,}}>
       
       <div className=""style={{fontSize:"18px",color:"#111",fontWeight:"700"}}> 
        <div style={{display:"flex",justifyContent:"space-between",padding:"0px"}}>
 <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"10px",padding:"5px 25px",background:activeColorPickerValue?.color1}}>
  <div><BookOpenCheck    color={activeColorPickerValue?.color10} size={20}/></div>
        <div> {currentQuestionObject?.queType}</div>  
          </div>   
          
          <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"10px",padding:"5px 25px",background:activeColorPickerValue?.color1}}>
  <div><MessageCircleQuestion    color={activeColorPickerValue?.color10} size={20}/></div>
        <div> {currentQuestionObject?.difficultyLevel}</div>  
          </div>
          
          </div>
        <div style={{padding:"5px",marginTop:"10px"}}>
            Que No.{currentQuestionObject?.menuOrder} {currentQuestionObject?.queName}
        </div>
     
 </div>


    {showQuestionOptions&&<QuestionOptionsStatic answerResponse={(status)=>{SetQuestionAnswered(currentQuestionObject,status);}} themeColor={activeColorPickerValue} questionObject={currentQuestionObject} questionType={currentQuestionObject?.queType} />}
      </div></div>:<div>
       <div className="palletMockTopTitle">
  
    <div onClick={()=>{setQuestionPaperVisible(true);}}  style={{border:"2px solid #888",width:"80px",borderRadius:"5px",height:"40px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",fontWeight:"999",fontSize:"14px"}}><div   className="palletGridList" style={{background:"#fff"}}><ChevronLeft style={{position:"relative"}}   color={"#333"} size={20}/></div><div>Back</div></div>
     <div style={{fontSize:"19px",padding:"5px",fontWeight:"999",}}>Question Paper </div> </div>
    
    <div className="QPMockPalletInfo" style={{background:activeColorPickerValue?.color1}}>
  
  <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#ddd",color:"#333"}}
     ><Clock size={20} color={"#222"}/></div>
         <div className="palletInfoTitle">Total Time Spent:  {sectionStatsAll?.timeSpent?formatTime(sectionStatsAll?.timeSpent):formatTime(0)}</div> 
    </div>
   <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#ddd",color:"#333"}}
     >{sectionStatsAll?.notVisited}</div>
         <div className="palletInfoTitle"> Not Visited</div> 
    </div><div className="palletInfoBtn">
        <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     >{  sectionStatsAll?.answered}</div>    <div className="palletInfoTitle"> Answered</div> 
    </div><div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333333",color:"#ffffff"}}
     >{sectionStatsAll?.visited}</div>   <div className="palletInfoTitle"> Not Answered</div> 
    </div>
     <div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333",color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{sectionStatsAll?.markedAndNotAnswered}</div>
       <div className="palletInfoTitle"> Not Answered And Marked</div> 
    </div><div className="palletInfoBtn">
       <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{sectionStatsAll?.markedAndAnswered}</div>    <div className="palletInfoTitle"> Answered And Marked</div> 
    </div>
  </div>



 {sectionsArr?.map((item,indexSec) =>(
          <div  key={item?.ID || indexSec}  
           >
            <div style={{display:"flex",justifyContent:"left"}}>
           
              <div style={{fontSize:"19px",padding:"5px",fontWeight:"999",marginTop:"5px"}}> Section:{indexSec+1} </div> 
        { 
        
        
        
        <div onClick={()=>{setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions));setCurrentSection(item);
             setCurrentSectionIndex(indexSec);setCurrentQuestionIndex(0);
               setCurrentQuestionObject(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[])
                 SetQuestionVisited(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[],"visited");
           
               setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
                handleQuestionClick(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]?.ID:"");
          }}
        
        className= {`quizSectionMoreItem ${item?.ID===currentSection?.ID?"activeQuizSection":""} `} style={{border:"2px solid "+(loadSections?findSectionIDBysection(item)=="true"?activeColorPickerValue?.color10:"#dddddd":"#dddddd"),background:(loadSections?findSectionIDBysection(item)=="true"?activeColorPickerValue?.color1:"#fff":"#fff")}}> <div className="ellipsisTitleQuiz" style={{width:" 120px",}}>  {item?.sectionName} </div>
        <div className="quizSectionMoreItemInn" >
            <div className="palletInfoTitle">  {item?.sectionName}</div>   
       <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{}} ><Clock size={20} color={"#222"}/>
     </div>
         <div className="palletInfoTitle"> Time Spent: {sectionsArr[indexSec]?.sectionStats?.timeSpent?formatTime(sectionsArr[indexSec]?.sectionStats?.timeSpent):formatTime(0)}</div> 
    </div> <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#ddd",color:"#333"}}
     >{sectionsArr[indexSec]?.sectionStats?.notVisited}</div>
         <div className="palletInfoTitle"> Not Visited</div> 
    </div><div className="palletInfoBtn">
        <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     >{sectionsArr[indexSec]?.sectionStats?.answered}</div>    <div className="palletInfoTitle"> Answered</div> 
    </div><div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333333",color:"#ffffff"}}
     >{sectionsArr[indexSec]?.sectionStats?.visited}</div>   <div className="palletInfoTitle"> Not Answered</div> 
    </div>
    <div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333",color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{sectionsArr[indexSec]?.sectionStats?.markedAndNotAnswered}</div>
       <div className="palletInfoTitle"> Not Answered And Marked</div> 
    </div><div className="palletInfoBtn">
       <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{sectionsArr[indexSec]?.sectionStats?.markedAndAnswered}</div>    <div className="palletInfoTitle"> Answered And Marked</div> 
    </div>
      </div>
      </div>}
      
      </div>

{
  // question Data Here
}

{getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)?.length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)?.map((itemQuestion, index) => 
        (
        <div  index={index} key={itemQuestion?.ID} 
        
          
        
        onClick={()=>{setCurrentQuestionObject(itemQuestion);SetQuestionVisited(itemQuestion,"visited");
          setCurrentQuestionIndex(index);
        handleQuestionClick(itemQuestion?.ID)
        setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions));setCurrentSection(item);
             setCurrentSectionIndex(indexSec);
                  
               setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
               
        
        }}  >
          <div>
           <div className=" palletAllButtonsBoxListQP" style={{margin:"10px",minHeight:"100px",border:"1px solid "+activeColorPickerValue?.color10}}>
    <div>  {(sectionsArr[indexSec]?.secQuestions[index]?.ID==itemQuestion?.ID)&&sectionsArr[indexSec]?.secQuestions[index]?.visited=="visited"&&sectionsArr[indexSec]?.secQuestions[index]?.answered!=="answered"&&sectionsArr[indexSec]?.secQuestions[index]?.marked!=="marked"?<div className="palletNotAttempdedButtonQP" 
     style={{background:activeColorPickerValue?.color1}}
     >{index<10?"0"+(index+1):(index+1)} Visited</div>
     :sectionsArr[indexSec]?.secQuestions[index]?.visited=="visited"&&sectionsArr[indexSec]?.secQuestions[index]?.answered=="answered"&&sectionsArr[indexSec]?.secQuestions[index]?.marked!=="marked"?<div className="palletAttempdedButtonQP" 
     style={{background:activeColorPickerValue?.color1}}
     ><div style={{marginTop:"10px"}}>{index<10?"0"+(index+1):(index+1)} Answered</div></div>
     :sectionsArr[indexSec]?.secQuestions[index]?.visited=="visited"&&sectionsArr[indexSec]?.secQuestions[index]?.answered!=="answered"&&sectionsArr[indexSec]?.secQuestions[index]?.marked=="marked"?
     <div className="palletNotAttempdedButtonQP"   
     style={{background:activeColorPickerValue?.color1}}
     ><div className="palletAttempdedButtonInnQP"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{index<10?"0"+(index+1):(index+1)} Marked</div>
     :sectionsArr[indexSec]?.secQuestions[index]?.visited=="visited"&&sectionsArr[indexSec]?.secQuestions[index]?.answered=="answered"&&sectionsArr[indexSec]?.secQuestions[index]?.marked=="marked"?
     <div className="palletAttempdedButtonQP" 
     style={{background:activeColorPickerValue?.color1}}
     ><div className="palletAttempdedButtonInnQP"  style={{background:activeColorPickerValue?.color10,color:"#fff",}}
     ></div><div style={{marginTop:"10px"}}>{index<10?"0"+(index+1):(index+1)}</div> <div style={{position:"relative",fontSize:"13px",marginTop:"12px",left:"-7px"}}>Marked & Answered</div> </div> :<div className="palletNotAttempdedButtonQP" style={{background:activeColorPickerValue?.color1}}>{index<10?"0"+(index+1):(index+1)} Not Visited</div>
     
     } 

     <div>
       <div style={{display:"flex",justifyContent:"space-between",padding:"0px",marginTop:"10px",fontSize:"12px"}}>
 <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"5px",padding:"5px 5px",background:activeColorPickerValue?.color1}}>
  <div><BookOpenCheck    color={activeColorPickerValue?.color10} size={15}/></div>
        <div> {itemQuestion?.queType}</div>  
          </div>   
          
          <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"5px",padding:"5px 5px",background:activeColorPickerValue?.color1}}>
  <div><MessageCircleQuestion    color={activeColorPickerValue?.color10} size={15}/></div>
        <div> {itemQuestion?.difficultyLevel}</div>  
          </div>
          
          </div>
            <div className="" style={{ display:"flex",borderRadius:"5px",justifyContent:"space-between" ,}}> 
          <div className="" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",margin:"5px",marginLeft:"0px",gap:"5px"
          ,background:activeColorPickerValue?.color1,fontSize:"12px"}}> <Clock style={{position:"relative"}} 
  color={activeColorPickerValue?.color10} size={15}/> {formatTimeQue(getTimerByActiveID(itemQuestion?.ID))}</div>
           {itemQuestion?.enableDisplayMarks=="true"?<div style={{display:"flex",justifyContent:"space-between",gap:"10px",padding:"5px"}}>
 <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:activeColorPickerValue?.color1,
  fontSize:"12px"
 }}>

       <Plus style={{position:"relative"}}   color={activeColorPickerValue?.color10} size={15}/>
          {itemQuestion?.marks}
          </div> <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:activeColorPickerValue?.color1
            ,fontSize:"12px"
          }}>
 <Minus style={{position:"relative"}}   color={activeColorPickerValue?.color10} size={15}/>
            {itemQuestion?.negativeMarks}
          </div>   </div>:""}
     </div>
     </div>
     </div>
    
 

   
    <div className="" >
        <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"5px",padding:"5px 5px",background:activeColorPickerValue?.color1}}>
  Section: {indexSec+1} {item?.sectionName} </div>
       <div className=" "  style={{fontSize:"19px",padding:"5px",fontWeight:"999",margin:"0px"}}> Que {index+1} : {itemQuestion?.queName}
        
       <div style={{width:"300px"}}>  <QuestionRichContent  postParentId={itemQuestion?.ID}/>
          </div>  </div>
          <div style={{padding:"5px"}} >
      {itemQuestion?.options?.map((option,index)=>(<>
       <div  style={{ }}>
      <div className="" style={{ display:"flex",borderRadius:"5px",justifyContent:"left" ,background:"#fff",
    borderRadius:"5px",fontWeight:"999",fontWeight:"500",color:"#888",fontSize:"14px"}}>
     {index+1}: {option?.optionText}</div></div></>))}</div>
        </div>
       </div>
    </div> 
          </div>)):""}



      
      
       </div>))}

</div>}

      </div>
       { testDesignValue=="pallet"&&palletDirection=="right"?<div></div>:""}
    {testDesignValue=="pallet"?<>
    {testDesignValue=="pallet"&&palletDirectionTemp==="left"?<div style={{width:"15px",height:"35px",background:"#222222",position:"absolute",top:"48%",left:"5px",display:"flex",
  justifyContent:"center",alignItems:"center",zIndex:"999999",cursor:"pointer"}}
  onClick={()=>{setPalletDirection("left");}}
  >
  <ChevronRight    color={"#ffffff"} size={20}/>
</div>:<div style={{width:"15px",height:"35px",background:"#222222",position:"absolute",top:"48%",right:"5px",display:"flex",
  justifyContent:"center",alignItems:"center",zIndex:"999999",cursor:"pointer"}}
   onClick={()=>{setPalletDirection("right")}} >
  <ChevronLeft    color={"#ffffff"} size={20}/>
</div>}
      <div   className={testDesignValue=="pallet"&&palletDirection==="left"?"TestInterfaceLeft":testDesignValue=="pallet"&&palletDirection==="right"?"TestInterfaceRight":"" }
      style={{borderRadius: '0px',border:"5px solid #fff",padding:"0px" ,display:`${testDesignValue=="pallet"&&(palletDirection==="left"||palletDirection==="right")?"block":"none"}`}}>

{testDesignValue=="pallet"&&palletDirection==="left"?<div style={{width:"15px",height:"35px",background:"#222222",position:"absolute",top:"48%",right:"-5px",display:"flex",
  justifyContent:"center",alignItems:"center",zIndex:"999999",cursor:"pointer"}}
  onClick={()=>{setPalletDirection("");setPalletDirectionTemp("left");}}
  >
  <ChevronLeft    color={"#ffffff"} size={20}/>
</div>:<div style={{width:"15px",height:"35px",background:"#222222",position:"absolute",top:"48%",left:"-5px",display:"flex",
  justifyContent:"center",alignItems:"center",zIndex:"999999",cursor:"pointer"}}
   onClick={()=>{setPalletDirection("");setPalletDirectionTemp("right");}} >
  <ChevronRight    color={"#ffffff"} size={20}/>
</div>}

<div className="palletMockTop">
   <ImageWithFallbackCircle src={"https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D"}
    widthOuter={"50px"}
    fireOpenEdit ={()=>{}}  iconSize={28} setOpenFullImg={()=>{}}/>
   <div style={{fontSize:"15px",padding:"10px",fontWeight:"999",paddingLeft:"20px"}}>Kaushal </div> </div> 
   
 
  <div className="palletMockTopTitle">
   <div style={{fontSize:"19px",padding:"5px",fontWeight:"999",}}>Question Pallet </div>
    <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{}} ><Clock size={20} color={"#222"}/>
     </div>
         <div className="palletInfoTitle"> Time Spent: {sectionsArr[currentSectionIndex]?.sectionStats?.timeSpent?formatTime(sectionsArr[currentSectionIndex]?.sectionStats?.timeSpent):formatTime(0)}</div> 
    </div>
</div>
 <div className="palletMockTopPalletInfo">
   <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#ddd",color:"#333"}}
     >{sectionsArr[currentSectionIndex]?.sectionStats?.notVisited}</div>
         <div className="palletInfoTitle"> Not Visited</div> 
    </div><div className="palletInfoBtn">
        <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     >{  sectionsArr[currentSectionIndex]?.sectionStats?.answered}</div>    <div className="palletInfoTitle"> Answered</div> 
    </div><div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333333",color:"#ffffff"}}
     >{sectionsArr[currentSectionIndex]?.sectionStats?.visited}</div>   <div className="palletInfoTitle"> Not Answered</div> 
    </div>
  </div><div className="palletMockTopPalletInfoTwo">
    <div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#333",color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{sectionsArr[currentSectionIndex]?.sectionStats?.markedAndNotAnswered}</div>
       <div className="palletInfoTitle"> Not Answered And Marked</div> 
    </div><div className="palletInfoBtn">
       <div className="palletAttempdedButtonSmall" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ><div className="palletAttempdedButtonInnSmall"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{sectionsArr[currentSectionIndex]?.sectionStats?.markedAndAnswered}</div>    <div className="palletInfoTitle"> Answered And Marked</div> 
    </div>
  </div>
  <div className="palletMockTopPalletBox">
   
  <div className="palletGridListTitle" style={{}}>{currentSection?.sectionName}</div>  
   
   
        <div className="palletGridList" onClick={()=>{setPalletType("Grid")}} style={{background:palletType=="Grid"?activeColorPickerValue?.color10:"#fff",color:palletType=="Grid"?"#fff":"#333"}}>
                 <Grid2x2 style={{position:"relative"}}   color={palletType=="Grid"?"#fff":activeColorPickerValue?.color10} size={25}/> <div>Grid</div></div> 
    <div   className="palletGridList" onClick={()=>{setPalletType("List")}}  style={{background:palletType=="List"?activeColorPickerValue?.color10:"#fff",color:palletType=="List"?"#fff":"#333"}}>
        <ChartNoAxesGantt style={{position:"relative"}}   color={palletType=="List"?"#fff":activeColorPickerValue?.color10} size={25}/><div>List</div></div>
</div>

<div className="palletAllButtonsBoxOuter">
    {palletType=="Grid"?
 <div className="palletAllButtonsBox">

 {questionsArr?.length?questionsArr?.map((itemQuestion, index) => 
        ( <div   index={index} key={itemQuestion?.ID} 
          
          onMouseEnter={()=>{  if(index % 5===2||index % 5===3||index % 5===4){setButtonQuestionObject({que:itemQuestion,dir:"left"});}
          else{setButtonQuestionObject({que:itemQuestion,dir:"right"});}}}
  onMouseLeave={()=>setButtonQuestionObject({})}
          onClick={()=>{setCurrentQuestionObject(itemQuestion);SetQuestionVisited(itemQuestion,"visited");
            
          setCurrentQuestionIndex(index);
        handleQuestionClick(itemQuestion?.ID)}} >
         {(sectionsArr[currentSectionIndex]?.secQuestions[index]?.ID==itemQuestion?.ID)&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered!=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked!=="marked"?<div className="palletNotAttempdedButton" 
     style={{background:"#333333",color:"#fff"}}
     >{index<10?"0"+(index+1):(index+1)}</div>
     :sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked!=="marked"?<div className="palletAttempdedButton" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     >{index<10?"0"+(index+1):(index+1)}</div>
     :sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered!=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked=="marked"?
     <div className="palletNotAttempdedButton"   
     style={{background:"#333333",color:"#fff"}}
     ><div className="palletAttempdedButtonInn"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{index<10?"0"+(index+1):(index+1)}</div>
     :sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked=="marked"?
     <div className="palletAttempdedButton" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ><div className="palletAttempdedButtonInn"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{index<10?"0"+(index+1):(index+1)}</div> :<div className="palletNotAttempdedButton" style={{background:"#dddddd"}}>{index<10?"0"+(index+1):(index+1)}</div>} 


          </div>)):""}
    
  
 </div>:<div> 
  {questionsArr?.length?questionsArr?.map((itemQuestion, index) => 
        (
        <div  index={index} key={itemQuestion?.ID} 
        
          onMouseEnter={()=>{  if(testDesignValue=="pallet"&&palletDirection==="right"){setButtonQuestionObject({que:itemQuestion,dir:"left"});}
          else{setButtonQuestionObject({que:itemQuestion,dir:"right"});}}}
  onMouseLeave={()=>setButtonQuestionObject({})}
        
        onClick={()=>{setCurrentQuestionObject(itemQuestion);SetQuestionVisited(itemQuestion,"visited");
          setCurrentQuestionIndex(index);
        handleQuestionClick(itemQuestion?.ID)}}  >
           <div className=" palletAllButtonsBoxList">
      {(sectionsArr[currentSectionIndex]?.secQuestions[index]?.ID==itemQuestion?.ID)&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered!=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked!=="marked"?<div className="palletNotAttempdedButton" 
     style={{background:"#333333",color:"#fff"}}
     >{index<10?"0"+(index+1):(index+1)}</div>
     :sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked!=="marked"?<div className="palletAttempdedButton" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     >{index<10?"0"+(index+1):(index+1)}</div>
     :sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered!=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked=="marked"?
     <div className="palletNotAttempdedButton"   
     style={{background:"#333333",color:"#fff"}}
     ><div className="palletAttempdedButtonInn"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{index<10?"0"+(index+1):(index+1)}</div>
     :sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked=="marked"?
     <div className="palletAttempdedButton" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ><div className="palletAttempdedButtonInn"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{index<10?"0"+(index+1):(index+1)}</div> :<div className="palletNotAttempdedButton" style={{background:"#dddddd"}}>{index<10?"0"+(index+1):(index+1)}</div>} 

    <div className="ellipsisTitleQuizTwoRows" style={{width:"270px",fontSize:"16px",padding:"8px",fontWeight:"700",marginTop:"-5px"}}>
        {itemQuestion?.queName} 
        </div>
       
    </div> 
          </div>)):""}
   
    
    
    </div>}
 </div>

<div className="instructionQPOuterGrid   " >
 <div className="" style={{border:"2px solid #444",borderRadius:"5px",height:"40px",display:"flex",justifyContent:"center",alignItems:"center",margin:"0px",marginTop:"10px",marginRight:"10px",marginBottom:"5px",fontWeight:"999",fontSize:"14px"}}><div   className="palletGridList" style={{background:"#fff"}}><Newspaper style={{position:"relative"}}   color={"#333"} size={20}/></div><div>Question Paper</div></div>
<div className="" style={{border:"2px solid #444",borderRadius:"5px",height:"40px",display:"flex",justifyContent:"center",alignItems:"center",margin:"0px",marginTop:"10px",marginLeft:"10px",marginBottom:"5px",fontWeight:"999",fontSize:"14px"}}><div   className="palletGridList" style={{background:"#fff"}}><FlameKindling style={{position:"relative"}}   color={"#333"} size={25}/></div><div>Instructions</div></div>
</div>

      </div></>:""}
   

      
      </div>
      
      
       </div>
     {testDesignValue=="pagenation"?
      <div   className={testDesignValue=="pagenation"&&pagenationDirection==="top"?"TestInterfaceTopPagenation":testDesignValue=="pagenation"&&pagenationDirection==="bottom"?"TestInterfaceBottomPagenation":""}
       style={{borderRadius: '0px',border:"5px solid #fff",background:"#ffffff",boxShadow:"10px 7px 20px 10px rgba(0, 0, 0, 0.04)"}}>
 <div className="carousel-container" >
        {questionsArr?.length?questionsArr?.map((itemQuestion, index) => (
          <div className="carousel-slide " index={index} key={itemQuestion?.ID} 
            onMouseEnter={()=>{  if(pagenationDirection==="top"){setButtonQuestionObject({que:itemQuestion,dir:"top"});}
          else{setButtonQuestionObject({que:itemQuestion,dir:"bottom"});}}}
  onMouseLeave={()=>setButtonQuestionObject({})}
          
          onClick={()=>{setCurrentQuestionObject(itemQuestion);SetQuestionVisited(itemQuestion,"visited");
          setCurrentQuestionIndex(index);
          handleQuestionClick(itemQuestion?.ID)}} >
        {(sectionsArr[currentSectionIndex]?.secQuestions[index]?.ID==itemQuestion?.ID)&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered!=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked!=="marked"?<div className="palletNotAttempdedButton" 
     style={{background:"#333333",color:"#fff"}}
     >{index<10?"0"+(index+1):(index+1)}</div>
     :sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked!=="marked"?<div className="palletAttempdedButton" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     >{index<10?"0"+(index+1):(index+1)}</div>
     :sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered!=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked=="marked"?
     <div className="palletNotAttempdedButton"   
     style={{background:"#333333",color:"#fff"}}
     ><div className="palletAttempdedButtonInn"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{index<10?"0"+(index+1):(index+1)}</div>
     :sectionsArr[currentSectionIndex]?.secQuestions[index]?.visited=="visited"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.answered=="answered"&&sectionsArr[currentSectionIndex]?.secQuestions[index]?.marked=="marked"?
     <div className="palletAttempdedButton" 
     style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ><div className="palletAttempdedButtonInn"  style={{background:activeColorPickerValue?.color10,color:"#fff"}}
     ></div>{index<10?"0"+(index+1):(index+1)}</div> :<div className="palletNotAttempdedButton" style={{background:"#dddddd"}}>{index<10?"0"+(index+1):(index+1)}</div>}   </div>)):""} </div>
      </div>:""}
      
<style>{`
.carousel-container {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  width: 100%;
}

.carousel-container::-webkit-scrollbar {
  display: none;
}

.carousel-slide {
  flex: 0 0 50px;cursor:pointer;
  scroll-snap-align: start;
  position: relative;
}
`}
  


</style>

       <div   className="TestInterfaceBottom " style={{borderRadius: '0px',}}>
{currentQuestionObject?.enableQueHint?<div className="mockQueHintClass hideXsForMock "
 style={{background:activeColorPickerValue?.color2,border:"2px solid "+activeColorPickerValue?.color10}}>
  Hint </div>:""}

<div className="MockBottomOuter">
<div className="MockBottomInnerLeft hideXsForMock">
    <div className="MockButtonBorder " onClick={()=>{SetQuestionMarked(currentQuestionObject,"marked");}}
     style={{background:activeColorPickerValue?.color2,border:"2px solid "+activeColorPickerValue?.color10}}>Mark For Review</div>
      <div onClick={()=>{SetQuestionClearResponse(currentQuestionObject,"");}} className="MockButtonBorder" style={{background:activeColorPickerValue?.color2,border:"2px solid "+activeColorPickerValue?.color10}}>Clear Response</div>
      </div> <div className="MockBottomInnerRight">
       <div className="showXsOnlyForMock">
          <div style={{display:"flex",justifyContent:"space-between",gap:"10px"}}>
          {currentQuestionObject?.enableQueHint?<div className="showXsOnlyForMock "><div className="mockQueHintClassTwo  "
 style={{background:activeColorPickerValue?.color2,border:"2px solid "+activeColorPickerValue?.color10,}}>
  <ShieldQuestionIcon    color={activeColorPickerValue?.color10} size={20}/> </div>  </div> :""}
   <div onClick={()=>{SetQuestionMarked(currentQuestionObject,"marked");}} className="MockButtonBorder " style={{background:activeColorPickerValue?.color2,border:"2px solid "+activeColorPickerValue?.color10,width:"90px"}}>Mark</div>
      <div onClick={()=>{SetQuestionClearResponse(currentQuestionObject,"");}} className="MockButtonBorder" style={{background:activeColorPickerValue?.color2,border:"2px solid "+activeColorPickerValue?.color10,width:"90px"}}>Clear</div>
      </div>
        </div>
       
 <div onClick={()=>{goTOPreviousQuestion()}} className="MockButtonBorder hideXsForMock" style={{background:activeColorPickerValue?.color2,border:"2px solid "+activeColorPickerValue?.color10}}>Previous </div>
        <div onClick={()=>{goTONextQuestion()}} className="MockButtonNext" style={{background:activeColorPickerValue?.color9,border:"2px solid "+activeColorPickerValue?.color9,color:"#222"}}>Save And Next</div></div>
        <div className="MockBottomInnerRightSubmit">
        <div className="MockButtonSubmit" style={{background:activeColorPickerValue?.color9,border:"2px solid "+activeColorPickerValue?.color9,color:"#222"}}>Submit Text</div>
   </div>
</div> 
      {openCalculator?  <ScientificCalculator onClose={()=>{setOpenCalculator(false)}} /> :""}
      </div>
      
        </div>


</>)
}
export default MockTest;